export enum MessageDismissReasonType {
  Timeout = 'timeout',
  Close = 'close',
  Action = 'action',
  Esc = 'esc',
  CloseAll = 'close-all',
  Clear = 'clear',
  // dismissed from code: a handle or useMessages().dismiss() without a reason
  Api = 'api',
  // the push was folded into an existing card with the same collapseKey (×N)
  Collapsed = 'collapsed',
  // the card was taken over by a push with the same replaceKey or id
  Replaced = 'replaced',
}
